import React, { useRef } from 'react';
import { ModalDialog } from 'react-bootstrap';
import Draggable from 'react-draggable';

export const DraggableModalDialog = (props) => {
  const nodeRef = useRef(null);
  
  return (
    <Draggable handle='.modal-header' nodeRef={nodeRef}>
      <div ref={nodeRef}>
        <ModalDialog {...props} />
      </div>
    </Draggable>
  );
};